import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    size: 2,
  },
  {
    arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  },
  {
    arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    size: 3,
  },
  {
    arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    size: 4,
  },
  {
    arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    size: 5,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr, size } = test;
      let outcome1 = output()(arr, size);
      let outcome2 = Solution(arr, size);
      const result = compare(outcome1, outcome2);
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
